import React, { useState, useEffect, useReducer } from 'react';
import _ from 'lodash';
import { useParams, Link } from 'react-router-dom';
import ScrollView from 'devextreme-react/scroll-view';
import { Toast } from 'devextreme-react/toast';
import * as utils from '../../common/utils'
import SelectBox from '../common/selectBox/SelectBox';
import LeftPanel from './LeftPanel';
import RightPanel from './RightPanel';
import Header from './Header';
import * as actions from '../../actions/siteDetails';
import { postUserLog } from '../../actions/common'
import ACTION_TYPES from '../../actions/actionTypes';
import siteReducer from '../../reducers/siteDetails';

const initialState = { template: null, tableuaData: null, isTemplateUpdate: null, isPreview: null, publishedTpl: null, userData: null, subTiers: [] };

const Customize = (props) => {
    const { site, tier, sbg } = useParams();
    const [state, dispatch] = useReducer(siteReducer, initialState);
    const [template1, updateTemplate] = useState(utils.defaultTemplate)
    const queryProps = utils.getUrlQueryData()
    const activeTab = queryProps.tab ? queryProps.tab : ''
    const [activeItem, updateActiveItem] = useState(0)
    const [publishing, setPublishing] = useState(false)
    const isBaseLayout = window.location.pathname.indexOf('tiers/layout') > -1 ? true : false;
    const [toastConfig, setToastConfig] = useState({
        isVisible: false,
        type: 'info',
        message: '',
    });
    const [tierLvl, setTierLvl] = useState('4');
    let { template, isTemplateUpdate, userData, isPreview, publishedTpl } = state

    
    const addRowLayout = (val) => {
        let tpl = template;
        if (tpl[activeItem]['layout'])
            tpl[activeItem]['layout'].push(utils.getRowLayoutByType(val))
        else {
            tpl[activeItem]['layout'] = []
            tpl[activeItem]['layout'].push(utils.getRowLayoutByType(val))
        }
        updateTpl(tpl)
        postUserLog({ event: 'Customize dashboard', data: { action: 'New row added', module: 'Customize dashboard', section: 'Customize', siteUId: site, widget: '' } })
    }

    const onWidgetSelect = (widget, grid, title, description, widgetId, filter) => {
        let tpl = template;
        let widgetTpl = utils.getWidgetTpl(widget, title, description);
        if (widgetId)
            widgetTpl['widgetId'] = widgetId;
        widgetTpl['filter'] = filter === 'All' ? '' : filter;
        if (!_.isArray(tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]])) {
            let prevWidget = tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]]
            if (prevWidget.itemId === widgetTpl.itemId)
                tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]] = [widgetTpl];
            else
                tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]] = [prevWidget, widgetTpl];
        } else {
            let widgets = tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]];
            if (grid[2] !== undefined) {
                tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]][grid[2]] = widgetTpl
            } else {
                if (widgets.length > 0) {
                    widgets.push(widgetTpl)
                    tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]] = widgets

                } else tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]] = [widgetTpl]
            }

        }

        updateTpl(tpl)
        postUserLog({ event: 'Customize dashboard', data: { action: 'Widget added ', module: 'Customize dashboard', section: 'Customize', siteUId: site, widget: '', } })
    }

    const deleteRow = i => {
        let tpl = template
        tpl[activeItem].layout.splice(i, 1);
        updateTpl(tpl)
        postUserLog({ event: 'Customize dashboard', data: { action: 'Row deleted', module: 'Customize dashboard', section: 'Customize', siteUId: site, widget: '', } })
    }

    const setVisibility = id => {
        let tpl = template;
        tpl.map(d => {
            if (d.id === id) {
                d['isActive'] = !d['isActive']
            }
            return d;
        })

        updateTpl(tpl)
    }

    const deleteWidget = (grid) => {
        let tpl = template;
        let col = tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]];
        col.splice(grid[2], 1);
        tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]] = col;
        updateTpl(tpl)
    }

    const setWidgetVisibility = (grid) => {
        let tpl = template;
        let widget;
        if (grid[2] !== undefined) {
            widget = tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]][grid[2]];
            widget["isActive"] = !widget.isActive
            tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]][grid[2]] = widget;
        } else {
            widget = tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]];
            widget["isActive"] = !widget.isActive
            tpl[activeItem]['layout'][grid[0]].rowItems[grid[1]] = widget;
        }

        updateTpl(tpl)
    }


    function onHiding() {
        setToastConfig({
            ...toastConfig,
            isVisible: false,
        });
    }

    useEffect(() => {
        if (isPreview) {

            window.open(`/preview/${sbg}/${site}/${tier}`)
        }
    }, [isPreview])

    useEffect(() => {
        let message = 'Changes Saved successfully.';
        if (publishing) {
            message = "Changes Published successfully."
        }

        if (isTemplateUpdate) {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'success',
                message
            });
        }
        setPublishing(false)

    }, [isTemplateUpdate])

    const updateTpl = (tpl, message) => {
        if (message) {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'success',
                message
            });
        }
        dispatch({ type: ACTION_TYPES.UPDATE_TEMPLATE_LOCAL, payload: tpl });
    }

    if (isBaseLayout && userData) {
        let type = userData.roleType[0].toLowerCase()
        if (type !== 'admin'){
             window.history.push('/');
        }
           
    }

    const reorderRows = (i, moveUp) => {
        let tpl = template;
        let rows = tpl[activeItem]['layout']
        if (moveUp) {
            let n = i;
            let prev = rows[n - 1];
            let current = rows[n];
            rows[n - 1] = current;
            rows[n] = prev;

        } else {
            let n = i;
            let prev = rows[n + 1];
            let current = rows[n];
            rows[n + 1] = current;
            rows[n] = prev;
        }
        tpl[activeItem]['layout'] = rows;
        updateTpl(tpl)
    }

    const reorderCols = (i, j, moveUp) => {
        let tpl = template;
        let rows = tpl[activeItem]['layout'][i]['rowItems']
        if (moveUp) {
            let n = j;
            let prev = rows[n - 1];
            let current = rows[n];
            rows[n - 1] = current;
            rows[n] = prev;

        } else {
            let n = j;
            let prev = rows[n + 1];
            let current = rows[n];
            rows[n + 1] = current;
            rows[n] = prev;
        }
        tpl[activeItem]['layout'][i]['rowItems'] = rows;
        updateTpl(tpl)
    }

    const reorderWidget = (i, j, k, moveUp) => {
        let tpl = template;
        let rows = tpl[activeItem]['layout'][i]['rowItems'][j]
        if (moveUp) {
            let n = k;
            let prev = rows[n - 1];
            let current = rows[n];
            rows[n - 1] = current;
            rows[n] = prev;

        } else {
            let n = k;
            let prev = rows[n + 1];
            let current = rows[n];
            rows[n + 1] = current;
            rows[n] = prev;
        }
        tpl[activeItem]['layout'][i]['rowItems'][j] = rows;
        updateTpl(tpl)
    }

    useEffect(() => {

        if (template && template.length > 0) {
            let tabVal = 0;
            if (activeTab) {

                tabVal = template.findIndex(d => d.id == activeTab)
            }
            if (!template[tabVal])
                tabVal = 0;
            updateActiveItem(tabVal)
        }

    }, [template])


    const saveTpl = (isPublish, isPreview) => {
        let tpl = template;

        if (isPublish) {
            setPublishing(true)
        }

        if (tpl.find(d => !d.title)) {

            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'warning',
                message: 'Please enter title for all the menu items.'
            });

        } else {
            let data = {
                "siteId": site,
                "tierId": tier,
                "isPublished": isPublish,
                "jsonData": template
            }

            if (isBaseLayout) {
                data.siteId = 'default'
                data.tierId = tierLvl
            }
            actions.updateTemplate(dispatch, data, isPreview)
        }

    }

    const revertTpl = () => {
        actions.fetchTemplate(dispatch, `siteid=${site}&tierid=${tier}`);
    }

    useEffect(() => {

        if (isBaseLayout) {
            actions.getUserData(dispatch, null);
            actions.fetchTemplate(dispatch, 'siteid=default&tierid=' + tierLvl);
        } else {
            actions.getSubTiers(dispatch, tier)
            actions.getUserData(dispatch, site);
            actions.fetchTemplate(dispatch, `siteid=${site}&tierid=${tier}&isFlag=true`);
            actions.getTableuaData(dispatch, tier);
            actions.fetchPublishedTpl(dispatch, `siteid=${site}&tierid=${tier}`);
            postUserLog({ event: 'Screen navigation', data: { action: 'Dashboard Customization View', module: 'Customize dashboard', section: 'Customize', siteUId: site, widget: '', } })
        }

    }, []);
    var tierList = utils.TIER_LIST

    return (
        <>{(template && userData) &&
            <>
                <Header isExpanded={true} />

                <section className="page-content page-height-change custom-dashboard">
                    <div className="dashboard-wrap">

                        <LeftPanel setVisibility={setVisibility} defaultTemplate={template} updateActiveItem={(i) => { updateActiveItem(i); postUserLog({ event: 'Customize menu change', data: { action: 'Menu changed to ' + template[i]['title'], module: 'Customize dashboard', section: 'Customize', siteUId: site, widget: '', } }) }} updateTemplate={updateTpl} activeMenu={activeItem} />
                        <div className="content-area">
                            <div className="content-head">
                                <div className="heading">
                                    <h2>{isBaseLayout ? 'Default Layout - ' : 'Customize your'} {template[activeItem] ? template[activeItem]['title'] : ""} Dashboard</h2>
                                </div>
                                {!isBaseLayout && <div className="buttons">
                                    {/*<Link to={`/preview/${sbg}/${site}/${tier}`}><button className="btn primary-btn">Preview</button></Link>*/}

                                    <Link to={`/dashboard/${sbg}/${site}/${tier}`}><button className="btn primary-btn" onClick={() => saveTpl(false, true)}>Back to Dashboard</button></Link>
                                    {!utils.isEqual(template, publishedTpl) && <button className="btn primary-btn" onClick={() => updateTpl(JSON.parse(JSON.stringify(publishedTpl)))}>Revert to published</button>}
                                    <button className="btn primary-btn" onClick={() => saveTpl(false, true)}>Preview</button>
                                    <button className="btn primary-btn" onClick={() => saveTpl(false, false)}>Save</button>
                                    <button className="btn secondary-btn" onClick={() => saveTpl(true, false)}>Publish</button>
                                </div>
                                }
                                {
                                    isBaseLayout && <>

                                        <div className="buttons">
                                            <div className="sa-tier-lvl-blk"><span>Tier Level:</span></div>
                                            <div className="sa-tier-lvl-bx"><SelectBox items={tierList} value={tierLvl} handleChange={(e) => { setTierLvl(e.id); actions.fetchTemplate(dispatch, 'siteid=default&tierid=' + e.id); }} /></div>

                                            <Link to={'/adminconsole'}><button className="btn primary-btn" >Back to Admin Console</button></Link>
                                            <button className="btn primary-btn" onClick={() => actions.fetchTemplate(dispatch, 'siteid=default&tierid=' + tierLvl)}>Revert</button>
                                            <button className="btn primary-btn" onClick={() => saveTpl(false, false)}>Save</button>
                                        </div></>
                                }
                            </div>
                            <p></p>
                        {(state.tableuaData || isBaseLayout) && <RightPanel subTiers={state.subTiers} isBaseLayout={isBaseLayout} reorderRows={reorderRows} reorderCols={reorderCols} tableuaData={state.tableuaData} site={site} tier={tier} addLayout={addRowLayout} template={template} rowData={template[activeItem] && template[activeItem]['layout'] ? template[activeItem]['layout'] : []} deleteRow={deleteRow} onWidgetSelect={onWidgetSelect} activeItem={activeItem} setWidgetVisibility={setWidgetVisibility} deleteWidget={deleteWidget} reorderWidget={reorderWidget} />}
                            <Toast
                                visible={toastConfig.isVisible}
                                message={toastConfig.message}
                                type={toastConfig.type}
                                onHiding={onHiding}
                                displayTime={2000}
                            />
                        </div>
                    </div>

                </section>
            </>}
        </>
    );
}
export default Customize
